import styled from "styled-components";

export const ContainerResumo = styled.div`
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 16px;
`;

export const LinhaInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
`;

export const CamposGroup = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  flex: 1;
`;

export const CampoResumo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 120px;
`;

export const LabelResumo = styled.span`
  font-size: 0.75rem;
  color: ${({ theme }) => theme.colors.neutral.neutral60};
  font-weight: 400;
`;

export const ValorResumo = styled.span`
  font-size: 0.875rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.neutral.neutral90};
`;

export const UrgenteLinha = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.neutral.neutral80};
  flex-shrink: 0;
  padding-top: 18px;
`;

export const ObservacaoResumo = styled.div`
  margin-top: 12px;
  padding-top: 10px;
`;

export const ObservacaoLabel = styled.div`
  font-size: 0.75rem;
  color: ${({ theme }) => theme.colors.neutral.neutral60};
  font-weight: 400;
  margin-bottom: 2px;
`;

export const ObservacaoTexto = styled.div`
  font-size: 0.875rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.neutral.neutral90};
`;

export const CustosAdicionados = styled.div`
  font-weight: normal;
  font-size: 0.95rem;
  margin-bottom: 12px;
  margin-top: 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ContainerTable = styled.div`
  max-height: 400px;
  overflow-y: auto;
`;

export const ContainerFechar = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const FlagUrgente = styled.span`
  color: #ee5353;
  font-size: 1rem;
`;

export const LinkRecibo = styled.a`
  color: ${({ theme }) => theme.colors.neutral.neutral90};
  text-decoration: none;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.neutral.neutral90};
  }
`;

export const BuscaWrapper = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 6px 10px;
  gap: 6px;
  width: 230px;
  background: #fff;
`;

export const BuscaIcone = styled.span`
  color: #9ca3af;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

export const BuscaInput = styled.input`
  border: none;
  outline: none;
  font-size: 0.85rem;
  flex: 1;
  background: transparent;
`;

export const AlertaAReceber = styled.span`
  color: #fe8f14;
  margin-left: 4px;
`;
